<template>
  <div class="widget" :class="{ 'no-header': !headerText }">
    <div style="position: relative;" class="widget-header" v-if="headerText">
      <div v-if="multi === 'Multi'" style="color: #4ab2e3;">
        <!-- <i class="fa fa-mars"></i>&nbsp; -->
      </div>
      <div v-if="multi === 'Single'" style="color: #db76df;">
        <!-- <i class="fa fa-venus"></i>&nbsp; -->
      </div>
      <div><span style="color: #adb3b9;">{{"Naziv kontrole: "}}</span>{{ headerText }}</div>
      <div style="width: 35%;">
        <span
          v-if="datum != ''"
          :id="datum"
          :class="{
            green: datum.trim() === today.trim(),
            red: datum.trim() != today.trim(),
          }"
        >
          &nbsp;{{ " | " }}{{ datum }}
         
        </span>
      </div>
    </div>
     <div style="position: relative;" class="widget-header" v-if="lotText">
     
      <div><span style="color: #adb3b9;">{{"LOT: "}}</span>{{ lotText }}</div>
    
    </div>

    <div class="widget-body">
      <slot></slot>
      <!-- Width: {{ window.width }},
      Height: {{ window.height }} -->
    </div>
  </div>
</template>

<script>
import { bus } from "../../../../main";
export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  name: "vuestic-widget-control",

  props: {
    headerText: {
      type: String,
      default: "",
    },
    lotText: {
      type: String,
      default: "",
    },
    multi: {
      type: String,
      default: "",
    },
    datum: {
      type: String,
      default: "",
    },
    today: {
      type: String,
      default: "",
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.widget {
  background: $widget-bg;
  box-shadow: $widget-box-shadow;
  margin-bottom: $widget-mb;
  padding: 0;

  &.no-header {
    .widget-body {
      height: $widget-body-no-header-height;
    }
  }

  &.larger-padding {
    .widget-body {
      padding: $widget-larger-padding;
    }
  }

  &.no-h-padding {
    .widget-body {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.no-v-padding {
    .widget-body {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &.brand-info {
    background-color: $brand-info;
    color: $white;
    box-shadow: $widget-info-shadow;
  }

  &.brand-danger {
    background-color: $brand-danger;
    color: $white;
    box-shadow: $widget-danger-shadow;
  }

  &.info-widget {
    border-top: $info-widget-border;

    &.brand-info {
      border-top-color: $brand-info;
    }

    &.brand-danger {
      border-top-color: $brand-danger;
    }
  }

  .widget-body {
    height: $widget-body-with-header-height;
    padding: $widget-padding;
  }

  .widget-header {
    height: $widget-header-height;
    padding: 0 $widget-padding;
    border-bottom: $widget-header-border;
    font-size: $font-size-larger;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .icon-bar a {
    color: #fff;
    text-decoration: none;
  }

  .icon-bar a:hover {
    color: #4ae387;
  }

  i:hover {
    color: #4ae387 !important;
  }

  .stop:hover {
    color: #e34a4a !important;
  }

  .container {
    display: flex;
  }

  .left {
    width: 30%;
  }

  .center {
    flex-grow: 1;
    text-align: center;
  }

  .right {
    width: 30%;
  }

  .red {
    font-size: 15px;
    color: #e34a4a;
  }

  .green {
    font-size: 15px;
    color: #4ae387;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/kontrole/pregled/components/VuesticWidget.vue